(() => {
  const script = document.currentScript;
  const fallbackSource = script?.dataset.stavDialogRuntime;
  const preferencesHash = '#shopifyReshowConsentBanner';
  const providerScript = document.getElementById('scb4127');
  const isSuppressed = new URLSearchParams(window.location.search).getAll('pb').includes('0');
  let fallbackPromise;
  let openingPromise;

  const providerReady = () => typeof window.privacyBanner?.showPreferences === 'function';

  const clearPreferencesHash = () => {
    if (window.location.hash !== preferencesHash) return;
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${window.location.search}`
    );
  };

  const openFromHash = () => {
    if (isSuppressed || window.location.hash !== preferencesHash || !providerReady()) return Promise.resolve();
    if (openingPromise) return openingPromise;
    openingPromise = Promise.resolve(window.privacyBanner.showPreferences())
      .then(() => {
        if (document.getElementById('shopify-pc__prefs__dialog')) clearPreferencesHash();
      })
      .finally(() => {
        openingPromise = undefined;
      });
    return openingPromise;
  };

  const loadFallback = () => {
    if (providerReady()) return Promise.resolve();
    if (!fallbackSource) return Promise.reject();
    if (fallbackPromise) return fallbackPromise;

    fallbackPromise = new Promise((resolve, reject) => {
      const fallback = document.createElement('script');
      fallback.src = fallbackSource;
      fallback.async = true;
      fallback.addEventListener('load', () => providerReady() ? resolve() : reject(), { once: true });
      fallback.addEventListener('error', reject, { once: true });
      document.head.appendChild(fallback);
    });

    return fallbackPromise;
  };

  const recover = () => {
    if (isSuppressed) return;
    if (providerReady()) {
      void openFromHash();
      return;
    }
    void loadFallback().then(openFromHash).catch(() => {});
  };

  if (providerScript) {
    providerScript.addEventListener('load', recover, { once: true });
    providerScript.addEventListener('error', recover, { once: true });
  }

  if (document.readyState === 'complete') recover();
  else window.addEventListener('load', recover, { once: true });
})();
